<template>
    <div>
        <div class="bg-white p-2">
            <div class="flex justify-between">
                <div class="flex">
                    <img class="border bg-gray-200 p-1 rounded-lg" src="../assets/analyt-icon.svg" alt="icon">
                    <p class="ml-2">Total Packages Sent</p>
                </div>
                <div class="text-xl text-blue-600 font-bold ml-6">
                    <p>{{totalWeeklyPackage}}</p>
                </div>
            </div>
            <div class="flex justify-end">
                <img src="../assets/analyt-icon2.svg" alt="icon">
                <p class="text-green-500">{{statsWeeklyPackage}}%</p>
            </div>
            
        </div>

        <div class="bg-white mt-4 p-2">
            <div class="flex justify-between">
                <div class="flex">
                    <img class="border bg-gray-200 p-1 rounded-lg" src="../assets/analyt-icon.svg" alt="icon">
                    <p class="ml-2">Total Buy for me orders</p>
                </div>
                <div class="text-xl text-blue-600 font-bold ml-6">
                    <p>{{totalWeeklyBuyForMe}}</p>
                </div>
            </div>
            <div class="flex justify-end">
                <img src="../assets/analyt-icon2.svg" alt="icon">
                <p class="text-green-500">{{statsWeeklyBuyForMe}}%</p>
            </div>
        </div>

        <div class="bg-white mt-4 p-2">
            <div class="flex justify-between">
                <div class="flex">
                    <img class="border bg-gray-200 p-1 rounded-lg" src="../assets/analyt-icon.svg" alt="icon">
                    <p class="ml-2">Total Haulage orders</p>
                </div>
                <div class="text-xl text-blue-600 font-bold ml-6">
                    <p>{{totalWeeklyHaulage}}</p>
                </div>
            </div>
            <div class="flex justify-end">
                <img src="../assets/analyt-icon2.svg" alt="icon">
                <p class="text-green-500">{{statsWeeklyHaulage}}%</p>
            </div>
        </div>

        <div class="bg-white mt-4 p-2">
            <div class="flex justify-between">
                <div class="flex">
                    <img class="border bg-gray-200 p-1 rounded-lg" src="../assets/analyt-icon.svg" alt="icon">
                    <p class="ml-2">Total Ride orders</p>
                </div>
                <div class="text-xl text-blue-600 font-bold ml-6">
                    <p>{{totalWeeklyRide}}</p>
                </div>
            </div>
            <div class="flex justify-end">
                <img src="../assets/analyt-icon2.svg" alt="icon">
                <p class="text-green-500">{{statsWeeklyRide}}%</p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            statsWeeklyHaulage : "",
            statsWeeklyPackage : "",
            statsWeeklyBuyForMe : "",
            statsWeeklyRide: "",
            totalWeeklyHaulage : "",
            totalWeeklyPackage : "",
            totalWeeklyBuyForMe : "",
            totalWeeklyRide: "",
            token: localStorage.getItem("token")
        }
    },

    mounted() {
        this.getWeeklyTotalHaulage();  
        this.getWeeklyTotalPackage(); 
        this.getWeeklyBuyForMe();  
        this.getWeeklyTotalRide();
    },
    methods: {
        getWeeklyTotalHaulage() {
            axios({
                method: 'GET',
                url:`${url}/v1/web/dashboard/orders?orderType=haulage&timeFrame=weekly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalWeeklyHaulage = total.total
                this.statsWeeklyHaulage = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },
        getWeeklyTotalPackage() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=package&timeFrame=weekly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalWeeklyPackage = total.total
                this.statsWeeklyPackage = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getWeeklyBuyForMe() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=buyForMe&timeFrame=weekly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalWeeklyBuyForMe = total.total
                this.statsWeeklyBuyForMe = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getWeeklyTotalRide() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=bookARide&timeFrame=weekly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalWeeklyRide = total.total
                this.statsWeeklyRide = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },

    }
}
</script>